import React from 'react';
import DropzoneComponent from 'react-dropzone-component';
import PropTypes from 'prop-types';
// component
import FontIcon from './../../FontIcon/FontIcon';
// css
import './Dropzone.scss';

const ReactDOMServer = require('react-dom/server');


class Dropzone extends React.Component {
	constructor(props) {
		super(props);
		this.auth = 'Basic ' + new Buffer('admin:admin').toString('base64');

		this.componentConfig = {
			showFiletypeIcon: true,
			postUrl: 'no-url'
		};

		this.dropzone = null;
	}

	// complete(file) {
	// 	this.props.completeFile(file);
	// }

	addedfile(file) {
		this.props.addedfile(file);
	}

	handlePost() {
		this.dropzone.processQueue();
	}

	render() {
		const { acceptedFiles } = this.props;
		const config = this.componentConfig;
		const djsHTML = (
			<div className="dz-preview dz-file-preview">
				<div className="dz-details">
					<div className="dz-filename"><h4 data-dz-name="true">&#9251;</h4></div>
				</div>
				<div className="dz-progress"><span className="dz-upload" data-dz-uploadprogress="true" /></div>
				<div className="dz-success-mark"><span data-dz-success-mark="true"><FontIcon iconName="save" size="small" /></span></div>
			</div>
		);
		const djsConfig = {
			addRemoveLinks: true,
			dictDefaultMessage: '<img src=\'./assets/images/svg/upload.svg\' />',
			acceptedFiles: acceptedFiles,
			autoProcessQueue: false,
			headers: { Authorization: this.auth },
			previewTemplate: ReactDOMServer.renderToStaticMarkup(djsHTML)
		};

		const eventHandlers = {
			init: dz => this.dropzone === dz,
			addedfile: this.addedfile.bind(this)
		};

		return (
			<div className="Dropzone">
				<DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig} />
			</div>
		);
	}
}

Dropzone.propTypes = {
	completeFile: PropTypes.func
};

Dropzone.defaultProps = {
	completeFile: () => {}
};

export default Dropzone;



// WEBPACK FOOTER //
// ./common/Forms/Dropzone/Dropzone.js